export enum TLDs {
  af = ".af",
  ax = ".ax",
  al = ".al",
  dz = ".dz",
  as = ".as",
  ad = ".ad",
  ao = ".ao",
  ai = ".ai",
  ag = ".ag",
  ar = ".ar",
  am = ".am",
  aw = ".aw",
  au = ".au",
  at = ".at",
  az = ".az",
  bs = ".bs",
  bh = ".bh",
  bd = ".bd",
  bb = ".bb",
  by = ".by",
  be = ".be",
  bz = ".bz",
  bj = ".bj",
  bm = ".bm",
  bt = ".bt",
  bo = ".bo",
  ba = ".ba",
  bw = ".bw",
  bv = ".bv",
  br = ".br",
  io = ".io",
  vg = ".vg",
  bn = ".bn",
  bg = ".bg",
  bf = ".bf",
  bi = ".bi",
  kh = ".kh",
  cm = ".cm",
  ca = ".ca",
  cv = ".cv",
  bq = ".bq",
  ky = ".ky",
  cf = ".cf",
  td = ".td",
  cl = ".cl",
  cn = ".cn",
  cx = ".cx",
  cc = ".cc",
  co = ".co",
  km = ".km",
  ck = ".ck",
  cr = ".cr",
  ci = ".ci",
  hr = ".hr",
  cu = ".cu",
  cw = ".cw",
  cy = ".cy",
  cz = ".cz",
  dk = ".dk",
  dj = ".dj",
  dm = ".dm",
  do = ".do",
  cd = ".cd",
  ec = ".ec",
  eg = ".eg",
  sv = ".sv",
  gq = ".gq",
  er = ".er",
  ee = ".ee",
  sz = ".sz",
  et = ".et",
  fk = ".fk",
  fo = ".fo",
  fj = ".fj",
  fi = ".fi",
  gf = ".gf",
  pf = ".pf",
  tf = ".tf",
  ga = ".ga",
  gm = ".gm",
  ge = ".ge",
  de = ".de",
  gh = ".gh",
  gi = ".gi",
  gr = ".gr",
  gl = ".gl",
  gd = ".gd",
  gu = ".gu",
  gt = ".gt",
  gg = ".gg",
  gn = ".gn",
  gw = ".gw",
  gy = ".gy",
  ht = ".ht",
  hm = ".hm",
  aq = ".aq",
  hn = ".hn",
  hk = ".hk",
  hu = ".hu",
  is = ".is",
  in = ".in",
  id = ".id",
  ir = ".ir",
  iq = ".iq",
  ie = ".ie",
  im = ".im",
  il = ".il",
  it = ".it",
  jm = ".jm",
  jp = ".jp",
  je = ".je",
  jo = ".jo",
  kz = ".kz",
  ke = ".ke",
  ki = ".ki",
  xk = ".xk",
  kw = ".kw",
  kg = ".kg",
  la = ".la",
  lv = ".lv",
  lb = ".lb",
  ls = ".ls",
  lr = ".lr",
  ly = ".ly",
  li = ".li",
  lt = ".lt",
  lu = ".lu",
  mo = ".mo",
  mg = ".mg",
  mw = ".mw",
  my = ".my",
  mv = ".mv",
  ml = ".ml",
  mt = ".mt",
  mh = ".mh",
  mq = ".mq",
  mr = ".mr",
  mu = ".mu",
  yt = ".yt",
  mx = ".mx",
  fm = ".fm",
  md = ".md",
  mc = ".mc",
  mn = ".mn",
  me = ".me",
  ms = ".ms",
  ma = ".ma",
  mz = ".mz",
  mm = ".mm",
  na = ".na",
  nr = ".nr",
  np = ".np",
  nl = ".nl",
  nc = ".nc",
  nz = ".nz",
  ni = ".ni",
  ne = ".ne",
  ng = ".ng",
  nu = ".nu",
  nf = ".nf",
  kp = ".kp",
  mk = ".mk",
  mp = ".mp",
  no = ".no",
  om = ".om",
  pk = ".pk",
  pw = ".pw",
  ps = ".ps",
  pa = ".pa",
  pg = ".pg",
  py = ".py",
  pe = ".pe",
  ph = ".ph",
  pn = ".pn",
  pl = ".pl",
  pt = ".pt",
  pr = ".pr",
  qa = ".qa",
  cg = ".cg",
  re = ".re",
  ro = ".ro",
  ru = ".ru",
  su = ".su",
  рф = ".рф",
  rw = ".rw",
  bl = ".bl",
  sh = ".sh",
  ac = ".ac",
  kn = ".kn",
  lc = ".lc",
  fr = ".fr",
  gp = ".gp",
  pm = ".pm",
  vc = ".vc",
  ws = ".ws",
  sm = ".sm",
  st = ".st",
  sa = ".sa",
  sn = ".sn",
  rs = ".rs",
  срб = ".срб",
  sc = ".sc",
  sl = ".sl",
  sg = ".sg",
  sx = ".sx",
  sk = ".sk",
  si = ".si",
  sb = ".sb",
  so = ".so",
  za = ".za",
  gs = ".gs",
  kr = ".kr",
  ss = ".ss",
  es = ".es",
  lk = ".lk",
  sd = ".sd",
  sr = ".sr",
  sj = ".sj",
  se = ".se",
  ch = ".ch",
  sy = ".sy",
  tw = ".tw",
  tj = ".tj",
  tz = ".tz",
  th = ".th",
  tl = ".tl",
  tg = ".tg",
  tk = ".tk",
  to = ".to",
  tt = ".tt",
  tn = ".tn",
  tr = ".tr",
  tm = ".tm",
  tc = ".tc",
  tv = ".tv",
  ug = ".ug",
  ua = ".ua",
  ae = ".ae",
  uk = ".uk",
  us = ".us",
  vi = ".vi",
  uy = ".uy",
  uz = ".uz",
  vu = ".vu",
  va = ".va",
  ve = ".ve",
  vn = ".vn",
  wf = ".wf",
  eh = ".eh",
  ye = ".ye",
  zm = ".zm",
  zw = ".zw"
}
export type TLD = `${TLDs}` | TLDs
